package org.chiangmeng.qfast.core.presentation.di

import org.chiangmeng.qfast.core.presentation.QueueViewModel
import org.chiangmeng.qfast.core.ui.customer.CustomerViewModel
import org.chiangmeng.qfast.core.ui.staff.StaffViewModel
import org.chiangmeng.qfast.core.ui.theme.ThemeManager
import org.chiangmeng.qfast.core.domain.ports.TicketPrinterService
import org.chiangmeng.qfast.core.domain.ports.TextToSpeechService
import org.chiangmeng.qfast.core.domain.ports.AuthRepository
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val uiModule = module {
    singleOf(::ThemeManager)
    factory { QueueViewModel(get(), get(), get(), get(), get()) }
    factory { StaffViewModel(get(), getOrNull(), getOrNull(), getOrNull()) }
    factoryOf(::CustomerViewModel)
}
